<template>
  <div>
    <v-container fluid>
      <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
        <v-toolbar-title class="title"
        :style="'color: #' + FontColorTitle"
          >Upload Sound To Document</v-toolbar-title
        >
        <v-spacer />
        <div class="d-flex pr-4">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
        </div>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="documentname-field-uploadsoundtodocument"
                      :label="'Document name'"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchDocName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-uploadsoundtodocument"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
              <v-btn
                v-if="canAdd"
                id="button-add-uploadsoundtodocument"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="speechDocumentData.total"
          :items="speechDocumentData.data"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td style="text-align: left">{{ item.documentName }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center; padding: 12px">
                <div class="d-flex justify-center">
                  <div class="status-container">
                    <v-chip
                      :color="getProcessStatusColor(item)"
                      variant="flat"
                      size="small"
                      class="status-chip"
                    >
                      <v-icon start size="14">
                        {{ getProcessStatusIcon(item) }}
                      </v-icon>
                      <span class="status-text"
                        >{{ item.inProcess }}/{{ item.processFinish }}</span
                      >
                    </v-chip>
                  </div>
                </div>
              </td>
              <td style="text-align: center; padding: 12px">
                <!-- Modern Action Container -->
                <div class="action-container">
                  <div class="action-group">
                    <!-- Edit Button -->
                    <v-btn
                      id="button-edit-popupedit-uploadsoundtodocument"
                      variant="text"
                      density="comfortable"
                      @click="EditSpeechDocument(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ canEdit ? 'Edit' : 'View' }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Import Button -->
                    <v-btn
                      v-if="canEdit"
                      id="button-popupimport-uploadsoundtodocument"
                      variant="text"
                      density="comfortable"
                      @click="ImportDocument(item)"
                      class="action-btn import-btn-action"
                      icon
                    >
                      <v-icon size="18">mdi-database-import-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Import to Knowledge Base
                      </v-tooltip>
                    </v-btn>

                    <!-- Action Divider -->
                    <div v-if="canEdit || canDelete" class="action-divider"></div>

                    <!-- Delete Button -->
                    <v-btn
                      v-if="canDelete"
                      id="button-delete-uploadsoundtodocument"
                      variant="text"
                      density="comfortable"
                      @click="DeleteById(item.id)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <!--Upload popup-->
    <v-container fluid>
      <v-dialog
        v-model="uploadDialog"
        max-width="900px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <div class="dialog-header dialog-header-add">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <div class="icon-background">
                    <v-icon color="white" size="28">mdi-cloud-upload</v-icon>
                  </div>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Upload Speech Files</h2>
                <p class="dialog-subtitle">
                  Upload and process audio files for transcription
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="Clear()"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <!-- Document Name and Language Row -->
            <v-row>
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Document Name *</label>
                  <v-text-field
                    id="dataname-field-uploadsoundtodocument"
                    v-model="dataName"
                    placeholder="Enter a descriptive name for your document"
                    variant="outlined"
                    :rules="[rules.required]"
                    required
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20"
                        >mdi-file-document-outline</v-icon
                      >
                    </template>
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Language</label>
                  <v-select
                    id="language-autocomplete-uploadsoundtodocument"
                    :items="langaugeType"
                    item-title="name"
                    item-value="value"
                    v-model="request.langPop"
                    variant="outlined"
                    hide-details
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-translate</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <!-- AI Model and Bot Summation Row -->
            <v-row class="mb-2">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">AI Model (for summation)</label>
                  <v-select
                    id="input-modelID-uploadsoundtodocument"
                    :items="listDDModelDisplayName"
                    :item-title="getItemModelNameText"
                    :item-value="getItemModelNameID"
                    :disabled="!botSummation"
                    v-model="modelDisplayID"
                    variant="outlined"
                    clearable
                    hide-details
                    placeholder="Select AI model for text summation"
                    class="modern-input"
                    :class="{ 'input-disabled': !botSummation }"
                    :rules="[v => !!v || 'Required.']" 
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20"
                        >mdi-robot-outline</v-icon
                      >
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-switch
                  id="botsummation-checkbox-uploadsoundtodocument"
                  v-model="botSummation"
                  color="primary"
                  hide-details
                  density="compact"
                  inset
                  class="inline-switch"
                >
                  <template #label>
                    <div class="inline-label">
                      <span class="mr-2">Bot Summation</span>
                      <v-icon
                        size="25"
                        :color="botSummation ? 'primary' : 'grey'"
                      >
                        mdi-file-document-edit-outline
                      </v-icon>
                    </div>
                  </template>
                </v-switch>
              </v-col>
            </v-row>

            <!-- File Upload Area -->
            <div class="upload-section">
              <div class="upload-header">
                <v-icon color="primary" class="mr-2"
                  >mdi-cloud-upload-outline</v-icon
                >
                <span class="upload-title">Upload Audio Files</span>
              </div>

              <v-card
                variant="outlined"
                class="upload-area-card"
                :class="{ 'drag-over': isDragOver }"
              >
                <MultipleDragAndDrop
                  :dialog.sync="uploadDialog"
                  :multiple="true"
                  @filesUploaded="processUpload($event)"
                  @dragover="isDragOver = true"
                  @dragleave="isDragOver = false"
                  @drop="isDragOver = false"
                />
              </v-card>

              <div class="upload-help-text">
                <v-icon size="16" color="grey" class="mr-1"
                  >mdi-information-outline</v-icon
                >
                <span
                  >Supported formats: MP3, WAV, M4A, FLAC (Max size: 100MB per
                  file)</span
                >
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left">
                <v-chip
                v-if="request.filesList && request.filesList.length > 0"
                color="success"
                variant="tonal"
                size="small"
              >
                <v-icon start size="16">mdi-file-multiple</v-icon>
                {{ request.filesList.length }} file(s) selected
              </v-chip>
              </div>
              <div class="actions-right">
                <v-btn
                variant="outlined"
                color="grey"
                @click="Clear()"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon start size="18">mdi-close</v-icon>
                Cancel
              </v-btn>

              <v-btn
                v-if="canAdd"
                id="button-save-popupupload-uploadsoundtodocument"
                color="success"
                variant="flat"
                @click="Save()"
                :loading="loading"
                class="dialog-action-btn save-btn-add"
                :disabled="!dataName || !request.filesList"
              >
                <v-icon start size="18">mdi-upload</v-icon>
                Upload Files
              </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!--Import popup-->
    <v-container fluid>
      <v-dialog
        v-model="importDocPopup"
        max-width="700px"
        persistent
        transition="dialog-bottom-transition"
        class="modern-dialog"
      >
        <v-card class="dialog-card">
          <!-- Dialog Header -->
          <v-card-title class="dialog-header dialog-header-edit">
            <div class="header-main">
              <div class="header-icon-container">
                <div class="icon-background">
                  <v-icon color="white" size="28">mdi-database-import</v-icon>
                </div>
              </div>
              <div class="header-text-content">
                <h2 class="dialog-title">Import To Knowledge Document</h2>
                <p class="dialog-subtitle">
                  Import processed content to knowledge base
                </p>
              </div>
            </div>
            <div class="header-actions">
              <v-btn
                icon
                variant="text"
                color="white"
                @click="importDocPopup = false"
                class="close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Dialog Content -->
          <v-card-text class="dialog-content">
            <v-row class="mb-4">
              <v-col cols="12" md="8">
                <div class="input-group">
                  <label class="input-label">Select Document *</label>
                  <v-select
                    id="importtoknowledgedocument-popupimport-uploadsoundtodocument"
                    :items="listDDLVector"
                    :item-title="getDocName"
                    :item-value="getDocId"
                    v-model="DocId"
                    :rules="[rules.required]"
                    variant="outlined"
                    clearable
                    hide-details="auto"
                    placeholder="Choose a knowledge document"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-database</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input-group">
                  <label class="input-label">Max Split Characters *</label>
                  <v-text-field
                    v-model="maxLimitedCharacter"
                    id="maxsplitcharactor-popupimport-uploadsoundtodocument"
                    type="number"
                    placeholder="5000"
                    clearable
                    :rules="[rules.required]"
                    variant="outlined"
                    hide-details="auto"
                    class="modern-input"
                  >
                    <template #prepend-inner>
                      <v-icon color="primary" size="20">mdi-format-text</v-icon>
                    </template>
                  </v-text-field>
                </div>
              </v-col>
            </v-row>

            <div class="info-card">
              <v-icon color="info" class="mr-2">mdi-information</v-icon>
              <div>
                <strong>Import Information:</strong><br />
                Document: <span class="text-primary">{{ documentName }}</span
                ><br />
                This will process and split the content for knowledge base
                integration.
              </div>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Dialog Actions -->
          <v-card-actions class="dialog-actions">
            <div class="actions-content">
              <div class="actions-left"></div>
              <div class="actions-right">
                <v-btn
                  variant="outlined"
                  color="grey"
                  @click="importDocPopup = false"
                  class="dialog-action-btn cancel-btn"
                >
                  <v-icon start size="18">mdi-close</v-icon>
                  Cancel
                </v-btn>

                <v-btn
                  id="upload-popupimport-uploadsoundtodocument"
                  variant="flat"
                  @click="SaveImport()"
                  :loading="loading"
                  class="dialog-action-btn save-btn-edit"
                  :disabled="!DocId || !maxLimitedCharacter"
                >
                  <v-icon start size="18">mdi-import</v-icon>
                  Import
                </v-btn>
              </div>
            </div>
            <!-- <v-spacer></v-spacer>

            <v-btn
              variant="outlined"
              color="grey"
              @click="importDocPopup = false"
              class="action-btn cancel-btn padding-btn"
            >
              <v-icon start size="18">mdi-close</v-icon>
              Cancel
            </v-btn>

            <v-btn
              id="upload-popupimport-uploadsoundtodocument"
              color="success"
              variant="flat"
              @click="SaveImport()"
              :loading="loading"
              class="action-btn import-btn padding-btn"
              :disabled="!DocId || !maxLimitedCharacter"
            >
              <v-icon start size="18">mdi-import</v-icon>
              Import
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- <v-overlay :value="loading">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay> -->
    <v-overlay :model-value="loading" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import MultipleDragAndDrop from "@/components/MultipleDragAndDrop.vue";
export default {
  name: "UploadSoundToDocument",
  components: { MultipleDragAndDrop },
  inject:[
    "FontColorTitle",
    "SubNavbarBackGround",
  ],
  data() {
    return {
      uploadDialog: false,
      importDocPopup: false,
      itemsPerPage: 10,
      dataName: "",
      today: null,
      isSearch: false,
      searchDocName: "",
      isDragOver: false,
      langauge: ["TH", "EN"],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      queryImport: 0,
      Axios_ControllerAduio: null,
      loading: false,
      botSummation: false,
      listDDLVector: [],
      DocId: 0,
      maxLimitedCharacter: 5000,
      langaugeType: [
        { name: "TH", value: "th-TH" },
        { name: "EN", value: "en-US" },
      ],
      listDDModelDisplayName: [],
      documentName: "",
      id: "",
      importList: [],
      rules: {
        required: (value) => !!value || "Required.",
      },
      request: {
        dataName: "",
        filesList: [],
        langPop: "th-TH",
      },
      speechDocumentData: {
        total: 0,
        sortDesc: false,
        sortBy: false,
        data: [
          {
            iD: 0,
            documentName: "",
            createDate: "",
            createBy: "",
            updateDate: "",
            updateBy: "",
            inProcess: 0,
            status: 0,
            activeFlag: null,
            processFinish: 0,
          },
        ],
      },
      modelDisplayID: 0,
      headers: [
        { title: "No.", align: "center", value: "number", sortable: false },
        {
          title: "Document",
          align: "center",
          value: "documentName",
          sortable: true,
        },
        {
          title: "Create by",
          align: "center",
          value: "createBy",
          sortable: true,
        },
        {
          title: "Process",
          align: "center",
          value: "inProcess",
          sortabe: false,
        },
        { title: "Action", align: "center", sortable: true },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.GetSpeechDocumentTable();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('UploadSoundToDocument');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('UploadSoundToDocument'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('UploadSoundToDocument'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('UploadSoundToDocument'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('UploadSoundToDocument'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('UploadSoundToDocument'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('UploadSoundToDocument'),
      }
    },
    vectorProcess() {
      return this.speechDocumentData.data.inProcess;
    },
  },
  methods: {
    getProcessStatusColor(item) {
      if (item.inProcess === item.processFinish) return "success";
      if (item.inProcess > 0) return "warning";
      return "grey";
    },

    getProcessStatusIcon(item) {
      if (item.inProcess === item.processFinish) return "mdi-check-circle";
      if (item.inProcess > 0) return "mdi-clock-outline";
      return "mdi-circle-outline";
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; // January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Add() {
      this.uploadDialog = true;
    },

    processUpload(files) {
      let self = this;
      var validFiles = [];
      for (const file of files) {
        validFiles.push(file);
      }
      self.request.filesList = validFiles;
    },

    Save() {
      let self = this;
      if (!self.dataName) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      if (!this.request.langPop || this.request.langPop === '') {
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill All The Fields!',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      let formData = new FormData();
      self.request.dataName = self.dataName;
      self.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: self.Axios_ControllerAduio.signal,
      };

      self.request.filesList.forEach((file) => {
        formData.append(`FileSpeech`, file);
      });

      formData.append("LangPop", self.request.langPop);
      formData.append("dataName", self.request.dataName);
      formData.append("FileSpeech", self.request.filesList);
      if (self.modelDisplayID != 0 && self.botSummation == true) {
        formData.append("modelDisplay", self.modelDisplayID);
      }
      self.loading = true;
      try {
        self.$call.CreateSpeechDocument(
          formData,
          Config,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false 
              });
              self.loading = false;
              self.uploadDialog = false;
              self.GetSpeechDocumentTable();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.loading = false;
              self.uploadDialog = false;
            }
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.LogTrace(error, "Save");
      }
    },
    Clear() {
      let self = this;
      self.dataName = "";
      self.botSummation = false;
      self.uploadDialog = false;
    },
    GetSpeechDocumentTable() {
      let self = this;
      self.loadingTable = true;
      if (self.isSearch) {
        self.options.page = 1;
        self.options.itemsPerPage = 10;
      }
      self.isSearch = false;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        documentName: self.searchDocName,
        sortBy: sortField,
        sortDesc: sortOrder,
      };
      self.$call.GetSpeechDocument(
        tempData,
        (dataResponse) => {
          self.loadingTable = false;
          if (dataResponse.status == 0) {
            self.speechDocumentData.data = dataResponse.data.data;
            if (self.speechDocumentData.data.length != 0) {
              self.speechDocumentData.total = dataResponse.data.total;
              self.AutoRefresh();
            }
          }
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    RefreshSpeechDocumentTable() {
      let self = this;
      self.loading = false;
      const { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
      var tempData = {
        page: page,
        perPage: itemsPerPage,
        documentName: self.searchDocName,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetSpeechDocument(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.speechDocumentData.data = dataResponse.data.data;
            if (self.speechDocumentData.data.length != 0) {
              self.speechDocumentData.total = dataResponse.data.total;
            }
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetDDLVector() {
      let self = this;
      self.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDLVector = dataResponse.data;
          } else {
            self.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    EditSpeechDocument(item) {
      let self = this;
      self.$router.push({
        name: "UploadSoundToDocumentDetail",
        query: {
          id: item.id,
        },
      });
    },
    ConfirmImport() {
      let self = this;
      self.requestVector.modelType =
        self.requestVector.modelType == null || !self.requestVector.modelType
          ? self.modelType == null
            ? 1
            : self.modelType
          : self.requestVector.modelType;
      if (
        !self.Add.textORG ||
        !self.requestVector.modelType ||
        !self.searchVectorDBName2
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        self.requestVector.modelType == 3 &&
        !self.requestVector.customCharacter
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        this.requestVector.MaxLimitedCharacter == null ||
        this.requestVector.MaxLimitedCharacter == "" ||
        this.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      self.searchVectorDBName2 = self.searchVectorDBName2.trim();
      self.requestVector.vectordbName = self.searchVectorDBName2;
      let temp = {
        vectordbName: self.requestVector.vectordbName,
        modelType: self.requestVector.modelType,
        groupReplaceID:
          self.tempgroupReplaceID == null
            ? null
            : JSON.stringify(self.tempgroupReplaceID),
        Content: self.Add.textORG,
        flagNew: self.flagNew,
        customCharacter: self.requestVector.customCharacter,
        DetectLanguage: self.requestVector.DetectLanguage,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
      };
      self.dialog = true;
      try {
        self.$call.SaveAddVector(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.GetByVector();
              self.closeUploaddialogAdd();
            } else {
              self.VectorDBNameDuplicate = self.searchVectorDBName2;
              // self.searchVectorDBName2 = null;
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    getDocID(item) {
      return item.name;
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionAllQuestion"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.$call.DeleteSpeechDocument(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                      allowOutsideClick: true,
                      allowEscapeKey: true,
                      allowEnterKey: true,
                      backdrop: false
                    });
                    if (
                      self.speechDocumentData.data.length == 1 &&
                      self.options.page != 1
                    ) {
                      self.options.page -= 1; //ถ้าลบข้อมูลสุดท้ายของหน้านั้นๆให้บังคับกลับไปหน้าก่อน
                    }
                    self.GetSpeechDocumentTable();
                  }
                },
                (errorResource) => {
                  self.loading = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    ImportDocument(item) {
      this.importDocPopup = true;
      this.queryImport = item.processFinish;
      this.documentName = item.documentName;
      this.id = item.id;
    },
    SaveImport() {
      let self = this;
      self.loading = true;
      let getSpeechDocumentDetailPromise = new Promise((resolve, reject) => {
        var tempData = {
          page: 1,
          perPage: self.queryImport,
          documentName: self.documentName,
          id: self.id,
          sortBy: null,
          sortDesc: false,
        };
        self.$call.GetSpeechDocumentDetail(
          tempData,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let importList = [];
              dataResponse.data.data.forEach((item) => {
                if (item.summarizedText !== null) {
                  importList.push(item.summarizedText);
                } else {
                  importList.push(item.originalText);
                }
              });
              resolve(importList);
            } else {
              reject(new Error("Failed to get speech document details"));
            }
          },
          (errorResource) => {
            reject(errorResource);
          }
        );
      });

      getSpeechDocumentDetailPromise
        .then((importList) => {
          let temp = {
            vectordbName: self.DocId,
            modelType: 1,
            groupReplaceID: null,
            Content: importList,
            flagNew: false,
            customCharacter: null,
            DetectLanguage: true,
            MaxLimitedCharacter: self.maxLimitedCharacter,
          };

          return new Promise((resolve, reject) => {
            self.$call.ImportSpeech2Text(
              temp,
              (dataResponse) => {
                self.loading = false;
                if (dataResponse.status == 0) {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.importDocPopup = false;
                  resolve(dataResponse);
                } else {
                  reject(new Error("Failed to import speech to text"));
                }
              },
              (errorResource) => {
                self.loading = false;
                reject(errorResource);
              }
            );
          });
        })
        .catch((error) => {
          console.error(error);
          self.LogTrace(error, "SaveImport");
        });
    },

    Search() {
      let self = this;
      self.isSearch = true;
      self.GetSpeechDocumentTable();
    },
    getItemModelNameText(item) {
      if (this.modelDisplayID == 0) {
        this.modelDisplayID = 1;
      }
      return `${item.modelDisplayID}: ${item.name}`;
    },
    getItemModelNameID(item) {
      return item.modelDisplayID;
    },
    getDocName(item) {
      if (this.DocId == 0) this.DocId = item.id;
      return item.id;
    },
    getDocId(item) {
      return item.id;
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        for (let value of self.speechDocumentData.data) {
          if (value.inProcess < value.processFinish) {
            self.RefreshSpeechDocumentTable();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/UploadSoundToDocument") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModelDisplayName = dataResponse.data;
          } else {
            self.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.maxLimitedCharacter = dataResponse.data;
          } else {
            self.maxLimitedCharacter = null;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
  },

  mounted() {
    this.GetDate();
    this.GetModel();
    this.GetDDLVector();
    this.GetMaxLimitedCharacter();
  },
};
</script>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
}
.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-overlay--active {
  z-index: 2000 !important;
}

.row-style {
  margin-right: 1.5rem;
  margin-left: 1.5rem;
  margin-top: 0.5rem;
}

/* Dialog Styles */
.upload-dialog,
.import-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 0;
} */

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  margin-right: 1rem;
  backdrop-filter: blur(10px);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgba(255, 255, 255, 0.3);
}

.header-text .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  color: white;
}

.header-text .dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

.close-btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Dialog Content */
.dialog-content {
  padding: 2rem;
  background: #fafafa;
}

.input-group {
  margin-bottom: 1rem;
}

.input-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #424242;
  margin-bottom: 0.5rem;
}

.modern-input {
  background: white;
  border-radius: 12px;
}

.modern-input .v-field {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-input.input-disabled {
  opacity: 0.6;
}

/* Inline Switch Styles */
.inline-switch {
  margin: 15px 0 0 0;
  padding: 0.5rem 1rem;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(25, 118, 210, 0.1);
  width: 100%;
}

.inline-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1rem;
  color: #424242;
}

.inline-switch :deep(.v-switch__track),
.inline-switch :deep(.v-switch__thumb) {
  transform: scale(0.85);
}

/* Upload Section */
.upload-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.upload-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #424242;
}

.upload-area-card {
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
  background: #fafafa;
}
.upload-area-card :deep(.v-card) {
  width: 100% !important;
  border: none !important;
}
.upload-area-card :deep(.v-card .v-card-text .v-icon) {
  color: rgba(0, 0, 0, 0.377) !important;
}

.upload-area-card.drag-over {
  border-color: #1976d2;
  background: rgba(25, 118, 210, 0.05);
  transform: scale(1.02);
}

.upload-help-text {
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  font-size: 0.8rem;
  color: #757575;
}

/* Info Card */
.info-card {
  background: rgba(33, 150, 243, 0.05);
  border: 1px solid rgba(33, 150, 243, 0.2);
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  font-size: 0.875rem;
  color: #424242;
}

/* Dialog Actions */
.dialog-actions {
  background: white;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e0e0e0;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.cancel-btn {
  border-color: #bdbdbd;
  color: #757575;
}

.cancel-btn:hover {
  background: rgba(189, 189, 189, 0.1);
}

.upload-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.upload-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
  transform: translateY(-1px);
}

.import-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.import-btn:hover {
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
  transform: translateY(-1px);
}

/* Transitions */
.v-dialog-transition-enter-active,
.v-dialog-transition-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.v-dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

.padding-btn {
  padding: 0 1.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .header-content {
    padding: 1rem;
  }

  .dialog-content {
    padding: 1rem;
  }

  .dialog-actions {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .actions-left,
  .actions-right {
    width: 100%;
    justify-content: center;
  }
  .status-chip {
    min-width: 70px;
    font-size: 0.7rem;
  }

  .status-text {
    font-size: 0.7rem;
  }
}

.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-chip {
  font-weight: 500 !important;
  border-radius: 8px !important;
  min-width: 80px;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.status-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.status-text {
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 4px;
}

/* Status Colors */
.status-chip.v-chip--variant-flat.text-success {
  background: rgba(76, 175, 80, 0.1) !important;
  color: #388e3c !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.status-chip.v-chip--variant-flat.text-warning {
  background: rgba(255, 152, 0, 0.1) !important;
  color: #f57c00 !important;
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.status-chip.v-chip--variant-flat.text-grey {
  background: rgba(158, 158, 158, 0.1) !important;
  color: #616161 !important;
  border: 1px solid rgba(158, 158, 158, 0.2);
}

/* Icon styling */
.status-chip .v-icon {
  opacity: 0.8;
}
</style>
